var map = {
	"./BEATCyclothon/pic1.jpg": 8023,
	"./BEATCyclothon/pic10.jpg": 9751,
	"./BEATCyclothon/pic11.jpg": 5914,
	"./BEATCyclothon/pic12.jpg": 8517,
	"./BEATCyclothon/pic13.jpg": 1352,
	"./BEATCyclothon/pic14.jpg": 1355,
	"./BEATCyclothon/pic15.jpg": 9870,
	"./BEATCyclothon/pic16.jpg": 6601,
	"./BEATCyclothon/pic17.jpg": 4908,
	"./BEATCyclothon/pic18.jpg": 6623,
	"./BEATCyclothon/pic19.jpg": 4242,
	"./BEATCyclothon/pic2.jpg": 7096,
	"./BEATCyclothon/pic20.jpg": 8018,
	"./BEATCyclothon/pic21.jpg": 5951,
	"./BEATCyclothon/pic22.jpg": 2336,
	"./BEATCyclothon/pic23.jpg": 7917,
	"./BEATCyclothon/pic24.jpg": 6454,
	"./BEATCyclothon/pic3.jpg": 4709,
	"./BEATCyclothon/pic4.jpg": 7374,
	"./BEATCyclothon/pic5.jpg": 8683,
	"./BEATCyclothon/pic6.jpg": 1708,
	"./BEATCyclothon/pic7.jpg": 3321,
	"./BEATCyclothon/pic8.jpg": 6162,
	"./BEATCyclothon/pic9.jpg": 2543,
	"./Upcoming/Marathon_2025/JullyEvent2025.jpg": 5513,
	"./Upcoming/Marathon_2025/Marathon_2025.jpg": 8202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3443;